// @ts-nocheck
"use client";

import React, { createContext, useContext, useState } from "react";
import { AirportsFilterItem } from "Components/molecules/AirportsFilter/types";
import { EntityFilterItem } from "Components/molecules/EntityFilter/types";
import { FilterContextProps } from "./types";

const FilterContext = createContext<FilterContextProps | undefined>(undefined);

export const FilterProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [stops, setStops] = useState<number[]>([0, 1, 2, 3]);
  const [minPrice, setMinPrice] = useState<number>(0);
  const [maxPrice, setMaxPrice] = useState<number>(1000);
  const [priceRange, setPriceRange] = useState<[number, number]>([0, 1000]);
  const [airportsFrom, setAirportsFrom] = useState<AirportsFilterItem[]>([]);
  const [airportsTo, setAirportsTo] = useState<string[]>([]);
  const [airlines, setAirlines] = useState<string[]>([]);
  const [sellers, setSellers] = useState<string[]>([]);
  const [firstSectorTimeRange, setFirstSectorTimeRange] = useState<
    [number, number]
  >([0, 1439]);
  const [secondSectorTimeRange, setSecondSectorTimeRange] = useState<
    [number, number]
  >([0, 1439]);
  const [anchorFilterMobile, setAnchorFilterMobile] = useState<string>("");

  return (
    <FilterContext.Provider
      value={{
        stops,
        setStops,
        minPrice,
        setMinPrice,
        maxPrice,
        setMaxPrice,
        priceRange,
        setPriceRange,
        airportsFrom,
        setAirportsFrom,
        airportsTo,
        setAirportsTo,
        airlines,
        setAirlines,
        sellers,
        setSellers,
        firstSectorTimeRange,
        setFirstSectorTimeRange,
        secondSectorTimeRange,
        setSecondSectorTimeRange,
        anchorFilterMobile,
        setAnchorFilterMobile,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilterContext must be used within a FilterProvider");
  }
  return context;
};
